'use strict';

import 'react-app-polyfill/ie11';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import './sentry';
import './styles/index.css';

import { ApolloProvider } from 'react-apollo';
import { PersistGate } from 'redux-persist/es/integration/react';
import { Provider } from 'react-redux';
import { reactI18nextModule } from 'react-i18next';
import Promise from 'bluebird';
import React from 'react';
import ReactDOM from 'react-dom';
import UPParser from 'ua-parser-js';
import i18next from 'i18next';

import { client } from './javascripts/graphql/client';
import { store, persistor } from './javascripts/redux/store';
import App from './javascripts/pages/App';
import SplashPage from './javascripts/pages/SplashPage';

Promise.config({
  cancellation: true,
});

const isSupportedBrowser = () => {
  let parser = new UPParser();

  let browser = parser.getBrowser();
  let engine = parser.getEngine();

  /*
   * Black list
   */
  if (
    browser.name === 'Android Browser' ||
    browser.name === 'IE' ||
    engine.name === 'Trident' ||
    engine.name === 'EdgeHTML'
  ) {
    return false;
  }

  /*
   * Check Chrome version
   */
  if (browser.name === 'Chrome' && Number(browser.major) < 67) {
    return false;
  }

  return true;
};

const isSupportedOS = () => {
  let parser = new UPParser();

  /*
   * Check iOS version
   */
  if (parser.getOS().name === 'iOS') {
    const regex = /(\d+)/;
    let major = parser.getOS().version.match(regex);
    if (major[1] && Number(major[1]) < 10) {
      return false;
    }
  }

  return true;
};

window.addEventListener('DOMContentLoaded', () => {
  i18next.use(reactI18nextModule).init(
    {
      lng: 'ja',
      fallbackLng: 'ja',
      debug: false,
      resources: {
        ja: {
          translation: require('@sonyged/ext-proc/src/quiz-engine/locales/proc.ja.yaml'),
        },
      },
    },
    function (err, _t) {
      if (err) {
        alert(err);
        return;
      }

      let node = document.getElementById('main');

      if (!isSupportedBrowser()) {
        window.location = 'https://proc-error.sonyged.com/unsupported_browser_version.html';
        return;
      }
      if (!isSupportedOS()) {
        window.location = 'https://proc-error.sonyged.com/unsupported_ios_version.html';
        return;
      }

      ReactDOM.render(
        <ApolloProvider client={client}>
          <Provider store={store}>
            <PersistGate persistor={persistor} loading={<SplashPage />}>
              <App />
            </PersistGate>
          </Provider>
        </ApolloProvider>,
        node
      );
    }
  );
});

window.addEventListener('contextmenu', (e) => {
  e.preventDefault();
});

// Prevent webpage scaling in iOS
// For mor detail, see:
//  - https://stackoverflow.com/questions/37808180/disable-viewport-zooming-ios-10-safari
//  - https://qiita.com/peutes/items/d74e5758a36478fbc039
// Must explicitly set passive: false
//  -https://bugs.webkit.org/show_bug.cgi?id=182521
//
// pinch-to-zoom
document.addEventListener(
  'touchmove',
  function (event) {
    if (event.scale && event.scale !== 1) {
      event.preventDefault();
    }
  },
  { passive: false }
);
// double tap
let lastTouchEnd = 0;
document.addEventListener(
  'touchend',
  function (event) {
    var now = new Date().getTime();
    if (now - lastTouchEnd <= 500) {
      event.preventDefault();
    } else {
      lastTouchEnd = now;
    }
  },
  { passive: false }
);
